import axios from "axios";

export function shopEdit(businessData) {
  let id = businessData.businessId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`,
    data: {
      businessData
    }
  };
  return axios(config);
}

export function updateRichmenu(accountId) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function assignToSpecificSiAccount(data) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.shopId}/si-account`,
    data: data
  };
  return axios(configBusiness);
}

export function updatePrinter(accountId, shop, data) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/printers/${data.printer.did}`,
    params: shop,
    data
  }
  return axios(config);
}

export function updateInvoiceTitle(accountId, data) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice`,
    data
  }
  return axios(config);
}

export function updateInvoicePrinterParams(accountId, data) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice-printer`,
    data
  }
  return axios(config);
}

export function updatePosmw(accountId, id, data) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/mw-settings/${id}`,
    data
  };
  return axios(config);
}

export function updatePosDvrSetting(accountId, data) {
  console.log('Data: ', data);
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/dvr-settings/`,
    data
  };
  return axios(config);
}
export function updatePromotionAnno(shopId, data) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${shopId}/promotions/announcements`,
    data: data
  };
  return axios(configBusiness);
}